import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { Sort, Filter, GetParams } from 'common/types/admin-page.type';

const DEFAULT_PAGE = 1;
const DEFAULT_PER_PAGE = 25;

const usePrevious = <T extends unknown>(value: T): T | undefined => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export function useAdminParams<T>(filter: null | Filter<T>, sort: null | Sort<T>) {
  const { search } = useLocation();
  const [retval, setRetval] = useState<null | GetParams<T>>(null);
  const prevArguments = usePrevious({ filter, sort });

  useEffect(() => {
    if (prevArguments === undefined) return;
    if (filter === null || filter === prevArguments.filter) return;
    if (sort === null || sort === prevArguments.sort) return;

    const query = queryString.parse(search);
    const { currPage = DEFAULT_PAGE, perPage = DEFAULT_PER_PAGE } = query;

    setRetval({
      filter,
      sort,
      pagination: {
        currPage: Number(currPage),
        perPage: Number(perPage),
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, sort]);

  return retval;
}
